(function(){
const CFG=JSON.parse(document.getElementById("rak-config").textContent);
fetch(CFG.racks).then(r=>r.json()).then(function(DATA){


function setSV(){document.documentElement.style.setProperty("--sv",Math.min(innerHeight,900)+"px")}
setSV(); addEventListener("resize",setSV);
/* ---------- language ---------- */
let LANG="en"; // always English on entry
const T={
 en:{wholesale:"Wholesale account",h1:"Every RAK.<br>Tested. Boxed.",h1b:"Find yours in seconds.",sub:"Order direct, no account needed.",ph:"Part number or VIN",search:"Search",hint:"Number with or without “RP-”, the 17-character VIN, or a model: Corolla, Sentra, F150.",h2v:"Or search by vehicle.",clear:"Clear",make:"Make",model:"Model",year:"Year",selMake:"Select make",selModel:"Select model",buildH:"This is how a RAK rack is built.",buildLead:"Hover over each part.",rsub:"The three that move fastest on the island, one per type. Add them and order.",all:"All",hyd:"Hydraulic",eps:"Electric",man:"Manual",more:"See more",t1h:"OE specification",t1p:"Every unit is tested before it leaves the warehouse.",t2h:"Island-wide delivery",t2p:"Confirmed orders ship the same day.",t3h:"RAK warranty",t3p:"Direct factory backing, no middlemen.",hours:"Mon–Fri 8:00–5:00",legal:"Vehicle makes and logos belong to their respective owners and are shown only to identify fitment. RAK Steering Factory is not affiliated with any of those manufacturers.",viewOrder:"View order",yourOrder:"Your order",send:"Send order",checkout:"Checkout",remove:"Remove",added:"Added to cart",clearAll:"Remove all",cleared:"Order cleared.",undo:"Undo",core:"Refundable core charge",coreShort:"core, refundable",coreBack:"Returned when you send the old rack back",less:"Less",more2:"More",note:"WhatsApp opens with the order ready to send to sales.",noteCart:"Secure checkout. Card, ATH Móvil or pickup at the warehouse.",storyLead:"Keep scrolling. Ten parts, one at a time.",outroH:"Every part. Tested. Boxed.",outroP:"That is a RAK rack. Find yours in seconds.",outroBtn:"Search your part",rxH:"A RAK rack, piece by piece.",rxLead:"Scroll slowly. Eight pieces, one at a time.",
   part:"part",parts:"parts",unit:"unit",units:"units",rack:"Rack &amp; Pinion",inStock:"In stock",special:"Special order",add:"Add",inOrder:"In order",quote:"Quote",toQuote:"unit(s) to quote",fast:"Fast Movers.",empty:"<b>No results</b>Check the number or search by make, model and year. If it is not listed, call sales.",vinNoMake:"I do not recognize this VIN’s make. Pick the vehicle above.",vinPossible:"possible parts",vinPick:"pick the model above to narrow it down",vinCheck:"note: the VIN check digit does not add up",waTitle:"RAK Steering Factory order",waStore:"Store name:",waTown:"Town:"},
 es:{wholesale:"Cuenta mayorista",h1:"Cada RAK.<br>Probado. Empacado.",h1b:"Encuentra el tuyo en segundos.",sub:"Pide directo, sin cuenta.",ph:"Número de pieza o VIN",search:"Buscar",hint:"Número con o sin “RP-”, el VIN de 17 caracteres, o un modelo: Corolla, Sentra, F150.",h2v:"O busca por vehículo.",clear:"Limpiar",make:"Marca",model:"Modelo",year:"Año",selMake:"Selecciona la marca",selModel:"Selecciona el modelo",buildH:"Así se construye un rack RAK.",buildLead:"Pasa el cursor por cada pieza.",rsub:"Los tres que más ruedan en la isla, uno por tipo. Añádelos y pide.",all:"Todos",hyd:"Hidráulico",eps:"Eléctrico",man:"Manual",more:"Ver más",t1h:"Especificación OE",t1p:"Cada unidad se prueba antes de salir del almacén.",t2h:"Entrega en toda la isla",t2p:"Los pedidos confirmados salen el mismo día.",t3h:"Garantía RAK",t3p:"Respaldo directo de fábrica, sin intermediarios.",hours:"Lun–Vie 8:00–5:00",legal:"Las marcas y logos de vehículos pertenecen a sus respectivos dueños y se muestran únicamente para identificar compatibilidad. RAK Steering Factory no está afiliada a ninguno de esos fabricantes.",viewOrder:"Ver pedido",yourOrder:"Tu pedido",send:"Enviar pedido",checkout:"Pagar",remove:"Quitar",added:"Añadido al carrito",clearAll:"Quitar todo",cleared:"Pedido vaciado.",undo:"Deshacer",core:"Cargo de core reembolsable",coreShort:"de core, reembolsable",coreBack:"Se te devuelve cuando entregas el rack viejo",less:"Menos",more2:"Más",note:"Se abre WhatsApp con el pedido listo para enviar a ventas.",noteCart:"Pago seguro. Tarjeta, ATH Móvil o recogido en el almacén.",storyLead:"Sigue bajando. Diez piezas, una a una.",outroH:"Cada pieza. Probada. Empacada.",outroP:"Eso es un rack RAK. Encuentra el tuyo en segundos.",outroBtn:"Busca tu pieza",rxH:"Un rack RAK, pieza por pieza.",rxLead:"Baja despacio. Ocho piezas, una a una.",
   part:"pieza",parts:"piezas",unit:"unidad",units:"unidades",rack:"Rack &amp; Pinion",inStock:"En almacén",special:"Por encargo",add:"Añadir",inOrder:"En el pedido",quote:"Cotizar",toQuote:"unidad(es) a cotizar",fast:"Fast Movers.",empty:"<b>Sin resultados</b>Revisa el número o búscalo por marca, modelo y año. Si no aparece, llama a ventas.",vinNoMake:"No reconozco la marca de este VIN. Elige el vehículo arriba.",vinPossible:"piezas posibles",vinPick:"elige el modelo arriba para afinar",vinCheck:"ojo: el dígito de control del VIN no cuadra",waTitle:"Pedido RAK Steering Factory",waStore:"Nombre de la tienda:",waTown:"Pueblo:"}
};
const tr=k=>T[LANG][k];
function applyLang(){
  document.documentElement.lang=LANG;
  document.querySelectorAll("[data-i18n]").forEach(el=>{el.innerHTML=tr(el.dataset.i18n)});
  if(typeof CFG!=="undefined" && CFG.cart){ const b=document.getElementById("send"), n=document.querySelector("#drawer .note"); if(b) b.textContent=tr("checkout"); if(n) n.textContent=tr("noteCart"); }
  document.querySelectorAll("[data-i18n-ph]").forEach(el=>{el.placeholder=tr(el.dataset.i18nPh)});
  document.querySelectorAll("#lang span").forEach(s=>s.classList.toggle("on",s.dataset.l===LANG));
  TYPES.hyd=tr("hyd");TYPES.eps=tr("eps");TYPES.man=tr("man");
  if(window.__storyRefresh) window.__storyRefresh();
  if(window.__rxRefresh) window.__rxRefresh();
  if(typeof runLast==="function"){ runLast(); }
  if(typeof updateCart==="function" && cart.size) updateCart();
}
document.getElementById("lang").onclick=()=>{LANG=LANG==="en"?"es":"en";applyLang()};


const POPULAR = (CFG.popular||"RP-25856,RP-30380,RP-8006").split(",").map(s=>s.trim()).filter(Boolean);
const TYPES={hyd:"Hydraulic",eps:"Electric",man:"Manual"};
const LOGOS=new Set(["acura", "alfa-romeo", "audi", "bmw", "buick", "cadillac", "chevrolet", "chrysler", "daewoo", "daihatsu", "dodge", "eagle", "fiat", "ford", "freightliner", "honda", "hummer", "hyundai", "infiniti", "isuzu", "jaguar", "jeep", "kia", "land-rover", "lexus", "lincoln", "mazda", "mercedes-benz", "mercury", "mitsubishi", "nissan", "oldsmobile", "plymouth", "pontiac", "porsche", "ram", "renault", "saab", "saturn", "scion", "subaru", "suzuki", "toyota", "volkswagen", "volvo"]);
let typeFilter="";
const $ = s => document.querySelector(s);
const bySku = new Map(DATA.map(p=>[p.sku,p]));
const newest = p => p.fits.length?Math.max(...p.fits.map(f=>f[3])):0;
const byNew = (a,b)=>newest(b)-newest(a);
const fmt = n => n>0 ? "$"+n.toFixed(2) : tr("quote");

/* ---------- catalog index ---------- */
const makes = new Map();
for (const p of DATA) for (const [mk,md,y1,y2] of p.fits){
  if(!makes.has(mk)) makes.set(mk,new Map());
  const m = makes.get(mk);
  if(!m.has(md)) m.set(md,new Set());
  for(let y=y1;y<=y2;y++) m.get(md).add(y);
}
const makeSel=$("#make"), modelSel=$("#model"), yearSel=$("#year");
for(const mk of [...makes.keys()].sort()) makeSel.append(new Option(mk,mk));
{const names=[...makes.keys()].sort().filter(n=>LOGOS.has(n.toLowerCase().replace(/ /g,"-")));const s=names.map(n=>`<img src="${CFG.assets}logo-${n.toLowerCase().replace(/ /g,"-")}.png" alt="${n}" loading="lazy" draggable="false">`).join("");document.getElementById("brands").innerHTML=s+s;}
makeSel.onchange=()=>{
  modelSel.innerHTML=`<option value="">${tr("selModel")}</option>`; yearSel.innerHTML=`<option value="">${tr("year")}</option>`;
  yearSel.disabled=true;
  if(!makeSel.value){modelSel.disabled=true;return}
  for(const md of [...makes.get(makeSel.value).keys()].sort()) modelSel.append(new Option(md,md));
  modelSel.disabled=false; modelSel.focus();
};
modelSel.onchange=()=>{
  yearSel.innerHTML=`<option value="">${tr("year")}</option>`;
  if(!modelSel.value){yearSel.disabled=true;return}
  const ys=[...makes.get(makeSel.value).get(modelSel.value)].sort((a,b)=>b-a);
  for(const y of ys) yearSel.append(new Option(y,y));
  yearSel.disabled=false; yearSel.focus();
};
let lastQuery=null;
$("#ymmform").onsubmit=e=>{
  e.preventDefault();
  const mk=makeSel.value, md=modelSel.value, y=+yearSel.value;
  if(!mk) return makeSel.focus();
  lastQuery={kind:"ymm",mk,md,y}; runLast();
  $("#sku").value="";
  document.getElementById("grid").scrollIntoView({behavior:"smooth",block:"start"});
};
$("#clear").onclick=()=>{makeSel.value="";makeSel.onchange();$("#sku").value="";lastQuery=null;renderPopular()};

/* ---------- VIN (offline: make + year; model in production via NHTSA) ---------- */
const WMI={
 // Toyota / Lexus / Scion
 "JT":"Toyota","4T1":"Toyota","4T3":"Toyota","4T4":"Toyota","5TD":"Toyota","5TE":"Toyota","5TF":"Toyota","5TB":"Toyota","2T1":"Toyota","2T3":"Toyota","1NX":"Toyota","JTD":"Toyota","JTE":"Toyota","JTN":"Toyota","JTM":"Toyota","JTH":"Lexus","JTJ":"Lexus","2T2":"Lexus","58A":"Lexus","JTK":"Scion","JTL":"Scion",
 // Honda / Acura
 "1HG":"Honda","2HG":"Honda","JHM":"Honda","5FN":"Honda","5FP":"Honda","5J6":"Honda","19X":"Honda","3HG":"Honda","2HK":"Honda","JHL":"Honda","3CZ":"Honda","19U":"Acura","JH4":"Acura","5J8":"Acura","2HN":"Acura","5FR":"Acura",
 // Nissan / Infiniti
 "1N4":"Nissan","1N6":"Nissan","3N1":"Nissan","3N6":"Nissan","3N8":"Nissan","JN1":"Nissan","JN8":"Nissan","5N1":"Nissan","JN6":"Nissan","4N2":"Nissan","JNK":"Infiniti","JNR":"Infiniti","5N3":"Infiniti","JNX":"Infiniti",
 // Hyundai / Kia
 "KMH":"Hyundai","KM8":"Hyundai","5NP":"Hyundai","5NM":"Hyundai","KMF":"Hyundai","KNA":"Kia","KND":"Kia","5XX":"Kia","5XY":"Kia","3KP":"Kia",
 // Ford / Lincoln / Mercury
 "1FA":"Ford","1FB":"Ford","1FC":"Ford","1FD":"Ford","1FM":"Ford","1FT":"Ford","2FA":"Ford","2FM":"Ford","2FT":"Ford","3FA":"Ford","3FE":"Ford","1ZV":"Ford","3FR":"Ford","1LN":"Lincoln","5LM":"Lincoln","2LM":"Lincoln","1L1":"Lincoln","5L1":"Lincoln","1ME":"Mercury","2ME":"Mercury","4M2":"Mercury","1MR":"Mercury","3ME":"Mercury",
 // GM
 "1G1":"Chevrolet","1GC":"Chevrolet","1GN":"Chevrolet","2G1":"Chevrolet","3G1":"Chevrolet","1GB":"Chevrolet","KL1":"Chevrolet","3GN":"Chevrolet","2GN":"Chevrolet","3GC":"Chevrolet","KL8":"Chevrolet","1G2":"Pontiac","2G2":"Pontiac","5Y2":"Pontiac","6G2":"Pontiac","3G2":"Pontiac","1G4":"Buick","2G4":"Buick","3G5":"Buick","1G6":"Cadillac","1GY":"Cadillac","1G3":"Oldsmobile","1G8":"Saturn","5GZ":"Saturn","3GS":"Saturn","5GT":"Hummer","5GR":"Hummer","137":"Hummer",
 // Chrysler group
 "1B3":"Dodge","1B4":"Dodge","1B6":"Dodge","1B7":"Dodge","2B3":"Dodge","2B4":"Dodge","3B3":"Dodge","3B7":"Dodge","1D7":"Dodge","1D3":"Dodge","1D8":"Dodge","3D7":"Dodge","2D4":"Dodge","3D3":"Dodge","3D4":"Dodge","1C3":"Chrysler","1C8":"Chrysler","2C3":"Chrysler","2C4":"Chrysler","2C8":"Chrysler","3C4":"Chrysler","3C8":"Chrysler","2A4":"Chrysler","2A8":"Chrysler","1A8":"Chrysler","1C6":"Ram","3C6":"Ram","1C4":"Jeep","1J4":"Jeep","1J8":"Jeep","3C3":"Fiat","ZFA":"Fiat","1P3":"Plymouth","1P4":"Plymouth","2P4":"Plymouth","3P3":"Plymouth","2E3":"Eagle","4E3":"Eagle",
 // Mitsubishi / Mazda / Subaru / Suzuki / Isuzu / Daewoo / Daihatsu
 "JA3":"Mitsubishi","JA4":"Mitsubishi","4A3":"Mitsubishi","4A4":"Mitsubishi","6MM":"Mitsubishi","JA7":"Mitsubishi","ML3":"Mitsubishi","JM1":"Mazda","1YV":"Mazda","4F2":"Mazda","4F4":"Mazda","JM3":"Mazda","3MZ":"Mazda","3MY":"Mazda","JMZ":"Mazda","JF1":"Subaru","JF2":"Subaru","4S3":"Subaru","4S4":"Subaru","4S6":"Subaru","JS2":"Suzuki","JS3":"Suzuki","2S3":"Suzuki","JSA":"Suzuki","KL5":"Suzuki","5S3":"Suzuki","JAA":"Isuzu","JAC":"Isuzu","4S2":"Isuzu","JAB":"Isuzu","JAE":"Isuzu","1GG":"Isuzu","KLA":"Daewoo","JDA":"Daihatsu",
 // Europe
 "WBA":"BMW","WBS":"BMW","WBX":"BMW","4US":"BMW","5UX":"BMW","WBY":"BMW","WDB":"Mercedes Benz","WDC":"Mercedes Benz","WDD":"Mercedes Benz","4JG":"Mercedes Benz","W1K":"Mercedes Benz","W1N":"Mercedes Benz","WD3":"Mercedes Benz","WD4":"Mercedes Benz","WDF":"Mercedes Benz","1FV":"Freightliner","1FU":"Freightliner","WDY":"Freightliner","WDP":"Freightliner","WVW":"Volkswagen","WVG":"Volkswagen","3VW":"Volkswagen","1VW":"Volkswagen","9BW":"Volkswagen","WV1":"Volkswagen","WV2":"Volkswagen","AAV":"Volkswagen","WAU":"Audi","WA1":"Audi","TRU":"Audi","YV1":"Volvo","YV4":"Volvo","4V4":"Volvo","LYV":"Volvo","WP0":"Porsche","WP1":"Porsche","SAJ":"Jaguar","SAD":"Jaguar","SAL":"Land Rover","ZAR":"Alfa Romeo","YS3":"Saab","3G0":"Saab","VF1":"Renault"
};
const YEARCODES="ABCDEFGHJKLMNPRSTVWXY123456789";
function isVin(s){return /^[A-HJ-NPR-Z0-9]{17}$/.test(s)}
function vinCheck(v){ // North American check digit
  const tr={A:1,B:2,C:3,D:4,E:5,F:6,G:7,H:8,J:1,K:2,L:3,M:4,N:5,P:7,R:9,S:2,T:3,U:4,V:5,W:6,X:7,Y:8,Z:9};
  const w=[8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2]; let sum=0;
  for(let i=0;i<17;i++){const c=v[i];sum+=(isNaN(c)?tr[c]:+c)*w[i]}
  const r=sum%11; return v[8]===(r===10?"X":String(r));
}
function decodeVin(v){
  v=v.toUpperCase(); const make=WMI[v.slice(0,3)]||WMI[v.slice(0,2)]||null;
  const i=YEARCODES.indexOf(v[9]); if(i<0) return {make,year:null};
  const old=1980+i, nw=2010+i; let year;
  if("12345".includes(v[0])) year=/[A-Z]/.test(v[6])?nw:old;           // NA rule: 7th char letter = 2010+
  else { const hasNew=make&&makes.has(make)&&[...makes.get(make).values()].some(s=>s.has(nw)); year=(nw<=new Date().getFullYear()+1&&hasNew)?nw:old; }
  return {make,year,valid:"12345".includes(v[0])?vinCheck(v):null};
}
function runVin(v){
  const d=decodeVin(v);
  if(!d.make||!makes.has(d.make)){ render([],"VIN "+v,{q:v}); $("#rcount").textContent=tr("vinNoMake"); return; }
  makeSel.value=d.make; makeSel.onchange();
  if(d.year){ // keep only models that exist in that year
    [...modelSel.options].forEach(o=>{ if(o.value && !makes.get(d.make).get(o.value).has(d.year)) o.remove(); });
  }
  lastQuery={kind:"ymm",mk:d.make,md:"",y:d.year||0}; runLast();
  $("#rtitle").textContent=`VIN · ${d.make}${d.year?" "+d.year:""}`;
  $("#rcount").textContent=(current.length?current.length+" "+tr("vinPossible")+" · ":"")+tr("vinPick")+(d.valid===false?" · "+tr("vinCheck"):"");
  modelSel.focus({preventScroll:true});
  document.getElementById("grid").scrollIntoView({behavior:"smooth",block:"start"});
}

/* ---------- SKU / text search ---------- */
function norm(s){return s.toUpperCase().replace(/[^A-Z0-9]/g,"")}
function search(q){
  const n=norm(q); if(!n) return [];
  const bySkuHit=DATA.filter(p=>norm(p.sku).includes(n) || norm(p.sku.replace(/^RP-?/,"")).startsWith(n));
  if(bySkuHit.length) return bySkuHit.sort((a,b)=>norm(a.sku).length-norm(b.sku).length);
  const words=q.toUpperCase().split(/\s+/).filter(Boolean);
  return DATA.filter(p=>p.fits.some(f=>{const t=(f[0]+" "+f[1]).toUpperCase();return words.every(w=>t.includes(w))})).sort(byNew);
}
$("#skuform").onsubmit=e=>{e.preventDefault();runSku()};
$("#sku").oninput=()=>{ if($("#sku").value.trim().length>=3) runSku(); else if(!$("#sku").value.trim()) {lastQuery=null;renderPopular();} };
function runSku(){
  const q=$("#sku").value.trim(); if(!q){lastQuery=null;return renderPopular()}
  if(isVin(q.replace(/\s/g,""))) return runVin(q.replace(/\s/g,""));
  lastQuery={kind:"sku",q}; runLast();
}
function runLast(){
  if(!lastQuery) return renderPopular();
  if(lastQuery.kind==="sku") render(search(lastQuery.q),"“"+lastQuery.q+"”",{q:lastQuery.q});
  else{
    const {mk,md,y}=lastQuery;
    const hits=DATA.filter(p=>p.fits.some(f=>f[0]===mk && (!md||f[1]===md) && (!y||(y>=f[2]&&y<=f[3])))).sort(byNew);
    render(hits,[mk,md,y||""].filter(Boolean).join(" "),{mk,md,y});
  }
}

/* ---------- render ---------- */
let current=[], shown=0; const PAGE=24;
function renderPopular(){
  if(typeFilter){ render(DATA.filter(p=>p.t===typeFilter).sort(byNew).slice(0,6),TYPES[typeFilter]+".",{pop:true}); return; }
  render(POPULAR.map(s=>bySku.get(s)).filter(Boolean),tr("fast"),{pop:true});
}
async function liveSearch(q){
  if(typeof CFG==="undefined"||!CFG.cart) return [];
  try{
    const r=await fetch("/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product&resources[limit]=10",{headers:{Accept:"application/json"}});
    if(!r.ok) return [];
    const j=await r.json();
    const out=[];
    for(const it of (j.resources&&j.resources.results&&j.resources.results.products)||[]){
      const m=/\b(RP-[A-Z0-9-]+)/i.exec(it.title); if(!m) continue;
      const sku=m[1].toUpperCase(); if(bySku.has(sku)||gone.has(sku)) continue;
      let d=null; try{ d=await (await fetch("/products/"+it.handle+".js")).json(); }catch(e){}
      if(!d||d.product_type!=="Rack & Pinion") continue;
      const v=d.variants&&d.variants[0]; if(!v) continue;
      const tail=(it.title.split(" - ")[1]||"").split(" / ").map(x=>x.trim()).filter(Boolean);
      const fits=tail.map(x=>{ const y=/(\d{4})\s*[-–]\s*(\d{4})/.exec(x);
        return [x.replace(/\s*\d{4}\s*[-–]\s*\d{4}\s*$/,"").trim(),"",y?+y[1]:0,y?+y[2]:0]; });
      const p={sku,t:/E$/.test(sku)?"eps":"hyd",price:v.price/100,avail:!!v.available,fits,h:it.handle,vid:v.id,notes:[],fresh:true};
      DATA.push(p); bySku.set(sku,p); out.push(p);
    }
    return out;
  }catch(e){ return []; }
}
function render(list,title,ctx){
  if(typeFilter && !ctx.pop) list=list.filter(p=>p.t===typeFilter);
  current=list; shown=0; $("#rtitle").textContent=title; $("#rsub").hidden=!ctx.pop;
  $("#rcount").textContent=list.length?list.length+" "+(list.length===1?tr("part"):tr("parts")):"";
  $("#grid").innerHTML=""; window._ctx=ctx;
  if(!list.length){
    $("#grid").innerHTML='<li class="empty">'+tr("empty")+'</li>';
    $("#more").hidden=true;
    if(ctx&&ctx.q) liveSearch(ctx.q).then(found=>{
      if(!found.length||lastQuery.kind!=="sku"||lastQuery.q!==ctx.q) return;
      render(found,"“"+ctx.q+"”",{q:ctx.q});
    });
    return;
  }
  more();
}
function more(){
  const frag=document.createDocumentFragment();
  const batch=current.slice(shown,shown+PAGE);
  for(const p of batch) frag.append(card(p,window._ctx));
  $("#grid").append(frag); shown=Math.min(shown+PAGE,current.length);
  $("#more").hidden=shown>=current.length;
  liveUpdate(batch);
}

/* ---------- live price & stock from Shopify (never trust the static file for money) ---------- */
const live=new Map();
const gone=new Set();
function dropSku(sku){
  if(gone.has(sku)) return; gone.add(sku);
  bySku.delete(sku);
  const i=DATA.findIndex(x=>x.sku===sku); if(i>=0) DATA.splice(i,1);
  const j=current.findIndex(x=>x.sku===sku); if(j>=0){ current.splice(j,1); if(shown>0) shown--; }
  const el=document.querySelector('.card[data-sku="'+sku+'"]'); if(el) el.remove();
  if(cart.has(sku)){ cart.delete(sku); updateCart(); }
  const n=document.getElementById("rcount");
  if(n&&current.length) n.textContent=current.length+" "+(current.length===1?tr("part"):tr("parts"));
  if(!document.querySelectorAll("#grid .card").length && !current.length)
    document.getElementById("grid").innerHTML='<li class="empty">'+tr("empty")+'</li>';
}
let CORE=null;
async function loadCore(){
  if(typeof CFG==="undefined"||!CFG.cart||!CFG.core) return;
  try{
    const j=await (await fetch("/products/"+CFG.core+".js")).json();
    const v=j.variants&&j.variants[0];
    if(v&&v.available!==false) CORE={id:v.id,price:v.price/100};
  }catch(e){}
  if(CORE){ refreshBots(); if(cart.size) updateCart(); }
}
function coreNote(){ return CORE?'<span class="corenote">+'+fmt(CORE.price)+" "+tr("coreShort")+"</span>":""; }
function stockHtml(p){return p.avail?'<span class="stock ok">'+tr("inStock")+'</span>':'<span class="stock no">'+tr("special")+'</span>'}
async function liveUpdate(list){
  if(typeof CFG==="undefined"||!CFG.cart) return;
  await Promise.all(list.map(async p=>{
    if(!p.h) return;
    if(!live.has(p.sku)){
      try{
        const r=await fetch("/products/"+p.h+".js",{headers:{Accept:"application/json"}});
        if(r.status===404){ dropSku(p.sku); return; }
        if(!r.ok) return;
        const j=await r.json(); const v=j.variants&&j.variants[0];
        if(!v){ dropSku(p.sku); return; }
        live.set(p.sku,{price:v.price/100,avail:!!v.available,vid:v.id});
      }catch(e){return}
    }
    const l=live.get(p.sku); if(!l) return;
    p.price=l.price; p.avail=l.avail; p.vid=l.vid;
    const el=document.querySelector('.card[data-sku="'+p.sku+'"] .price');
    if(el) el.innerHTML=fmt(p.price)+"<small>"+stockHtml(p)+coreNote()+"</small>";
  }));
  if(cart.size) updateCart();
}
$("#morebtn").onclick=more;
loadCore();
function card(p,ctx){
  const li=document.createElement("li"); li.className="card "+p.t; li.dataset.sku=p.sku;
  const fits=p.fits.map(f=>{
    const hit = ctx.mk && f[0]===ctx.mk && (!ctx.md||f[1]===ctx.md) && (!ctx.y||(ctx.y>=f[2]&&ctx.y<=f[3]));
    return `<li class="${hit?"hit":""}"><b>${f[0]} ${f[1]}</b><span>${f[2]===f[3]?f[2]:f[2]+"–"+f[3]}</span></li>`;
  }).join("");
  const inCart=cart.has(p.sku);
  li.innerHTML=`
    <div class="top"><h3 class="sku">${p.sku.replace(/^([A-Z]+-?)/,"<i>$1</i>")}<small>${tr("rack")}</small></h3>
      <span class="chip ${p.t}">${TYPES[p.t]}</span></div>
    <ul class="fits">${fits}</ul>
    ${botHtml(p)}`;
  return li;
}
function botHtml(p){
  const l=cart.get(p.sku);
  if(!l) return `<div class="bot" data-q="0">
      <div class="price">${fmt(p.price)}<small>${stockHtml(p)}${coreNote()}</small></div>
      <button class="add" type="button" data-sku="${p.sku}">${tr("add")}</button>
    </div>`;
  return `<div class="bot on" data-q="${l.qty}">
      <div class="price">${fmt(p.price)}<small>${stockHtml(p)}${coreNote()}</small></div>
      <div class="cq"><button type="button" data-cd="-1" data-sku="${p.sku}" aria-label="${tr("less")}">−</button><output>${l.qty}</output><button type="button" data-cd="1" data-sku="${p.sku}" aria-label="${tr("more2")}">+</button></div>
      <div class="row2"><span class="added">${tr("added")}</span><button class="rm" type="button" data-rm="${p.sku}">${tr("remove")}</button></div>
    </div>`;
}
function refreshBots(){
  document.querySelectorAll(".card").forEach(c=>{
    const p=bySku.get(c.dataset.sku); if(!p) return;
    const bot=c.querySelector(".bot"); if(!bot) return;
    const l=cart.get(p.sku); const want=String(l?l.qty:0);
    if(bot.dataset.q===want) return;
    const t=document.createElement("div"); t.innerHTML=botHtml(p);
    bot.replaceWith(t.firstElementChild);
  });
}
document.addEventListener("click",e=>{
  const add=e.target.closest(".add");
  if(add){ const sku=add.dataset.sku; if(cart.has(sku)) cart.get(sku).qty++; else cart.set(sku,{qty:1}); updateCart(); return; }
  const step=e.target.closest("[data-cd]");
  if(step){ const l=cart.get(step.dataset.sku); if(l){ l.qty+=+step.dataset.cd; if(l.qty<=0) cart.delete(step.dataset.sku); updateCart(); } return; }
  const rm=e.target.closest("[data-rm]");
  if(rm){ cart.delete(rm.dataset.rm); updateCart(); return; }
  const co=e.target.closest("[data-co]");
  if(co){ goCheckout(co); return; }
});

/* ---------- order ---------- */
const cart=new Map();
let undo=new Map(), undoTimer=null, lastUnits=0;
function bump(){
  const bar=$("#orderbar"); bar.classList.remove("bump");
  void bar.offsetWidth; bar.classList.add("bump");
  setTimeout(()=>bar.classList.remove("bump"),700);
}
function clearAll(){
  if(!cart.size) return;
  undo=new Map([...cart].map(([s,l])=>[s,{qty:l.qty}]));
  cart.clear(); updateCart();
  clearTimeout(undoTimer); undoTimer=setTimeout(()=>{ undo=new Map(); updateCart(); },8000);
}
function undoClear(){
  clearTimeout(undoTimer);
  for(const [s,l] of undo) cart.set(s,{qty:l.qty});
  undo=new Map(); updateCart(); bump();
}
function updateCart(){
  let units=0,total=0,quote=0;
  for(const [s,l] of cart){units+=l.qty;const p=bySku.get(s);if(p.price>0)total+=p.price*l.qty;else quote+=l.qty}
  const hc=$("#hcart");
  if(hc){
    hc.hidden=!cart.size;
    $("#hcartn").textContent=units;
    $("#hcarttot").textContent=cart.size?"$"+(total+(CORE?CORE.price*units:0)).toFixed(2):"";
  }
  const bar=$("#orderbar");
  bar.classList.toggle("show",cart.size>0||undo.size>0);
  $("#obmain").hidden=!cart.size; $("#obundo").hidden=!(!cart.size&&undo.size>0);
  $("#obcount").innerHTML=cart.size+" "+(cart.size===1?tr("part"):tr("parts"))+`<span>${units} ${units===1?tr("unit"):tr("units")}</span>`;
  const coreTotal = CORE?CORE.price*units:0;
  $("#total").textContent="$"+(total+coreTotal).toFixed(2);
  $("#obtotal").textContent="$"+(total+coreTotal).toFixed(2); $("#totn").textContent=quote?quote+" "+tr("toQuote"):"";
  $("#lines").innerHTML=[...cart].map(([s,l])=>{const p=bySku.get(s);return `<li>
    <div><div class="sku">${s}</div><div class="fit">${p.fits.slice(0,2).map(f=>f[0]+" "+f[1]+" "+f[2]+"–"+f[3]).join(" · ")}${p.fits.length>2?" · +"+(p.fits.length-2):""}</div></div>
    <div class="qty"><button type="button" data-d="-1" data-sku="${s}" aria-label="Menos">−</button><output>${l.qty}</output><button type="button" data-d="1" data-sku="${s}" aria-label="Más">+</button></div>
    <div class="lp">${p.price>0?"$"+(p.price*l.qty).toFixed(2):tr("quote")}</div></li>`}).join("")
    + (CORE&&units?`<li class="corerow"><div><div class="sku">${tr("core")}</div><div class="fit">${tr("coreBack")}</div></div><div class="cqty">${units} ×</div><div class="lp">$${(CORE.price*units).toFixed(2)}</div></li>`:"");
  if(!cart.size) $("#drawer").classList.remove("open");
  refreshBots();
  if(units>lastUnits){ bump(); const h=$("#hcart"); if(h){ h.classList.remove("pop"); void h.offsetWidth; h.classList.add("pop"); setTimeout(()=>h.classList.remove("pop"),600); } }
  lastUnits=units;
}
$("#lines").addEventListener("click",e=>{
  const b=e.target.closest("button[data-d]"); if(!b) return;
  const l=cart.get(b.dataset.sku); l.qty+=+b.dataset.d; if(l.qty<=0) cart.delete(b.dataset.sku); updateCart();
});
$("#openorder").onclick=()=>$("#drawer").classList.add("open");
$("#hcart").onclick=()=>$("#drawer").classList.add("open");
$("#obcheckout").onclick=()=>goCheckout($("#obcheckout"));
$("#obclear").onclick=clearAll;
$("#obundobtn").onclick=undoClear;
$("#closeorder").onclick=()=>$("#drawer").classList.remove("open");
$("#drawer").addEventListener("click",e=>{if(e.target.id==="drawer")$("#drawer").classList.remove("open")});
document.addEventListener("keydown",e=>{if(e.key==="Escape")$("#drawer").classList.remove("open")});
$("#send").onclick=()=>goCheckout($("#send"));
async function goCheckout(btn){
  const lines=[...cart].map(([s,l])=>({sku:s,qty:l.qty}));
  if(!lines.length) return;
  // Shopify: add every line to the real cart and go to checkout; fall back to WhatsApp if something cannot be added
  if(typeof CFG!=="undefined" && CFG.cart){
    const items=lines.map(x=>({id:bySku.get(x.sku).vid,quantity:x.qty})).filter(x=>x.id);
    const units=lines.reduce((a,x)=>a+x.qty,0);
    if(CORE&&units) items.push({id:CORE.id,quantity:units});
    btn.disabled=true;
    try{
      await fetch("/cart/clear.js",{method:"POST",headers:{"Accept":"application/json"}});
      const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items})});
      if(r.ok){ location.href="/checkout"; return; }
    }catch(e){}
    btn.disabled=false;
  }
  const txt=`${tr("waTitle")}\n${lines.map(x=>`${x.qty} × ${x.sku}`).join("\n")}\n\n${tr("waStore")}\n${tr("waTown")}`;
  window.open("https://wa.me/"+(CFG.wa||"")+"?text="+encodeURIComponent(txt),"_blank","noopener");
}

/* ---------- category filters ---------- */
document.querySelectorAll("#cats button").forEach(b=>b.onclick=()=>{
  typeFilter=b.dataset.t;
  document.querySelectorAll("#cats button").forEach(x=>x.classList.toggle("on",x===b));
  runLast();
});
document.querySelector('#cats button[data-t=""]').classList.add("on");

/* ---------- USA badge: tilts and shines under the cursor ---------- */
(function(){
  const box=document.querySelector(".hero-badge"), img=box&&box.querySelector("img"); if(!img) return;
  if(matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  function move(e){
    const r=img.getBoundingClientRect(); const x=(e.clientX-r.left)/r.width-0.5, y=(e.clientY-r.top)/r.height-0.5;
    box.classList.add("live");
    img.style.transform=`rotateX(${(-y*30).toFixed(2)}deg) rotateY(${(x*34).toFixed(2)}deg) scale(1.12)`;
    img.style.filter=`drop-shadow(${(-x*32).toFixed(0)}px ${(20-y*26).toFixed(0)}px 34px rgba(0,0,0,.55)) brightness(${(1+0.24-Math.hypot(x,y)*0.3).toFixed(3)})`;
  }
  function leave(){ box.classList.remove("live"); img.style.transform=""; img.style.filter=""; }
  img.addEventListener("pointermove",move); img.addEventListener("pointerleave",leave);
  img.addEventListener("click",()=>{ img.animate([{transform:"rotateY(0deg) scale(1.08)"},{transform:"rotateY(360deg) scale(1.08)"}],{duration:900,easing:"cubic-bezier(.2,.8,.2,1)"}); });
})();

/* ---------- trust icons tap ---------- */
document.querySelectorAll(".t").forEach(b=>b.onclick=()=>{b.classList.remove("on");void b.offsetWidth;b.classList.add("on");setTimeout(()=>b.classList.remove("on"),1400)});

/* ===================== RX (el rack a pantalla completa) ===================== */
(function(){
  const sec=document.getElementById("rx"); if(!sec) return;
  const D={"canvas": {"w": 3072, "h": 5504}, "parts": {"p1": {"l": 21.322, "t": 5.614, "w": 57.422, "h": 3.87}, "p2": {"l": 29.753, "t": 14.68, "w": 40.527, "h": 8.939}, "p3": {"l": 4.036, "t": 29.451, "w": 91.927, "h": 3.634}, "p4": {"l": 19.336, "t": 37.918, "w": 61.523, "h": 16.097}, "p5": {"l": 31.999, "t": 57.304, "w": 36.198, "h": 7.431}, "p6": {"l": 29.688, "t": 68.714, "w": 33.626, "h": 5.541}, "p7": {"l": 64.811, "t": 69.677, "w": 5.664, "h": 3.616}, "p8": {"l": 29.915, "t": 78.525, "w": 40.365, "h": 8.903}, "p9": {"l": 21.387, "t": 92.387, "w": 57.389, "h": 3.561}}, "stops": [{"k": ["p1"], "es": "Barra axial", "pes": "Rosca limpia y tuerca de ajuste. Entra a la primera, sin forzar.", "en": "Inner tie rod", "pen": "Clean thread, jam nut. It goes in the first time, no forcing."}, {"k": ["p2"], "es": "Fuelle y abrazadera", "pes": "Goma nueva y abrazadera de acero. Ni agua ni tierra entran al rack.", "en": "Boot and clamp", "pen": "New rubber, steel clamp. No water, no dirt gets into the rack."}, {"k": ["p3"], "es": "Barra dentada", "pes": "Acero rectificado con dientes helicoidales. Es la que mueve las gomas.", "en": "Rack bar", "pen": "Ground steel, helical teeth. This is what turns the wheels."}, {"k": ["p4"], "es": "Carcasa de aluminio", "pes": "Aluminio fundido con las caras mecanizadas. Atornilla donde atornillaba la original.", "en": "Aluminium housing", "pen": "Cast aluminium, machined faces. It bolts in exactly where the original did."}, {"k": ["p5"], "es": "Motor eléctrico", "pes": "Aquí vive la asistencia. Conector sellado, sin bomba y sin mangueras.", "en": "Electric motor", "pen": "The assist lives here. Sealed connector, no pump, no hoses."}, {"k": ["p6", "p7"], "es": "Piñón, rodamiento y tuerca", "pes": "Traduce el giro del guía en movimiento de la barra. Torqueado y verificado en fábrica.", "en": "Pinion, bearing and nut", "pen": "Turns the steering input into travel. Torqued and verified at the factory."}, {"k": ["p8"], "es": "El otro fuelle", "pes": "Los dos lados se sellan igual. Ninguno se monta usado.", "en": "The other boot", "pen": "Both sides seal the same way. Neither one goes in used."}, {"k": ["p9"], "es": "La otra barra axial", "pes": "Salen de la misma línea, con la misma rosca y el mismo torque.", "en": "The other tie rod", "pen": "Same line, same thread, same torque, both sides."}], "end": {"es": "Todas en la misma caja.", "pes": "Probadas y empacadas antes de salir del almacén.", "en": "All of it, in one box.", "pen": "Tested and boxed before it leaves the warehouse."}}, ST=D.stops, N=ST.length;
  const stick=sec.querySelector(".rxstick"), view=document.getElementById("rxview"),
        nudge=document.getElementById("rxnudge"), canvas=document.getElementById("rxcanvas"),
        head=document.getElementById("rxtop"), card=document.getElementById("rxcard"),
        rail=document.getElementById("rxrail"), cue=document.getElementById("rxcue");
  const layers=[...canvas.querySelectorAll(".rxl")];
  const CW=1000, CH=CW*D.canvas.h/D.canvas.w;
  canvas.style.setProperty("--cw",CW+"px"); canvas.style.setProperty("--ch",CH+"px");
  const cn=card.querySelector(".n"), cb=card.querySelector("b"), cp=card.querySelector("p");
  const es=()=>LANG==="es";
  const clamp=(v,a,b)=>v<a?a:v>b?b:v, ease=t=>t*t*(3-2*t);

  const BOX=ST.map(s=>{
    let x0=1e9,y0=1e9,x1=-1e9,y1=-1e9;
    s.k.forEach(k=>{ const b=D.parts[k];
      x0=Math.min(x0,b.l); y0=Math.min(y0,b.t); x1=Math.max(x1,b.l+b.w); y1=Math.max(y1,b.t+b.h); });
    return {x:x0/100*CW, y:y0/100*CH, w:(x1-x0)/100*CW, h:(y1-y0)/100*CH};
  });

  // cada parada es un encuadre; una pieza muy larga son dos y la camara la recorre
  let KF=[], SEG=[], W0=0, H0=0;
  function build(W,H){
    const mob=W<760, kf=[];
    // la vista de cierre es mas pequena y mas arriba: el texto va debajo, sin pisarse
    const ov=e=>({cx:CW/2, cy:CH/2, s:e?Math.min(W*.60/CW,H*.52/CH):Math.min(W*.68/CW,H*.62/CH), fy:e?.42:.55});
    kf.push(Object.assign(ov(0),{i:-1}));
    BOX.forEach((b,i)=>{
      let s=Math.min(W*(mob?.92:.80)/b.w, H*(mob?.34:.46)/b.h);
      const minH=H*.13;
      if(b.h*s<minH) s=minH/b.h;                 // la pieza nunca se queda en una rayita
      const over=(b.w*s-W*.92)/s/2, cy=b.y+b.h/2, fy=mob?.38:.40, cx=b.x+b.w/2;
      if(over>CW*.02){ kf.push({cx:cx-over,cy,s,fy,i}); kf.push({cx:cx+over,cy,s,fy,i}); }
      else kf.push({cx,cy,s,fy,i});
    });
    kf.push(Object.assign(ov(1),{i:N}));
    KF=kf; SEG=kf.length-1; W0=W; H0=H;
    sec.style.setProperty("--rxn",SEG);
    FIRST=ST.map((_,i)=>kf.findIndex(f=>f.i===i));
  }
  let FIRST=[];

  ST.forEach((s,i)=>{
    const b=document.createElement("button");
    b.type="button"; b.innerHTML="<i></i>"; b.setAttribute("aria-label",s.en);
    b.onclick=()=>{ const span=sec.offsetHeight-stick.clientHeight;
      scrollTo({top:sec.getBoundingClientRect().top+scrollY+span*(FIRST[i]/SEG+.004),behavior:"smooth"}); };
    rail.appendChild(b);
  });
  const ticks=[...rail.children];

  let last=-9, raf=0, touched=false;
  addEventListener("touchstart",()=>{touched=true},{passive:true,once:true});
  function paint(k){            // -1 entrada, 0..N-1 piezas, N cierre
    head.classList.toggle("out",k>=0);
    cue.classList.toggle("out",k>=0);
    if(k<0) return;
    if(k>=N){ cn.textContent=""; cb.textContent=es()?D.end.es:D.end.en; cp.textContent=es()?D.end.pes:D.end.pen; return; }
    const s=ST[k];
    cn.textContent=String(k+1).padStart(2,"0")+" / "+String(N).padStart(2,"0");
    cb.textContent=es()?s.es:s.en; cp.textContent=es()?s.pes:s.pen;
    if(touched&&navigator.vibrate) try{navigator.vibrate(8)}catch(e){}  // solo despues de tocar la pantalla
  }

  function update(){
    raf=0;
    const r=sec.getBoundingClientRect(), H=stick.clientHeight, W=stick.clientWidth;
    if(W!==W0||H!==H0) build(W,H);
    if(r.bottom<-240||r.top>innerHeight+240) return;
    const span=Math.max(1,sec.offsetHeight-H);
    const P=clamp(-r.top/span,0,1);
    const j=Math.min(SEG-1,Math.floor(P*SEG)), p=P*SEG-j;
    const A=KF[j], B=KF[j+1], same=A.i===B.i;
    const u=same?ease(p):ease(clamp((p-.20)/.58,0,1));
    const cx=A.cx+(B.cx-A.cx)*u, cy=A.cy+(B.cy-A.cy)*u, fy=A.fy+(B.fy-A.fy)*u,
          s=Math.exp(Math.log(A.s)+(Math.log(B.s)-Math.log(A.s))*u);
    canvas.style.transform="translate("+(W/2-s*cx).toFixed(1)+"px,"+(H*fy-s*cy).toFixed(1)+"px) scale("+s.toFixed(4)+")";
    const act=same?A.i:(u<.5?A.i:B.i), on=act>=0&&act<N;
    sec.classList.toggle("zoom",on);
    layers.forEach(l=>l.classList.toggle("on",on&&ST[act].k.indexOf(l.dataset.k)>=0));
    ticks.forEach((t,i)=>t.classList.toggle("on",i===act));
    card.style.opacity=(on||act>=N)?(same?1:Math.pow(Math.abs(2*u-1),.7)):0;
    if(act!==last){ last=act; paint(act); }
  }
  const tick=()=>{ if(!raf) raf=requestAnimationFrame(update); };
  addEventListener("scroll",tick,{passive:true});
  addEventListener("resize",()=>{last=-9;W0=0;tick()});
  window.__rxRefresh=()=>{last=-9;tick()};

  // el rack se mueve con el dedo o el cursor: peso, no adorno
  const soft=!matchMedia("(prefers-reduced-motion:reduce)").matches;
  if(soft&&matchMedia("(hover:hover)").matches){
    view.addEventListener("pointermove",e=>{
      const b=view.getBoundingClientRect();
      const nx=((e.clientX-b.left)/b.width-.5)*2, ny=((e.clientY-b.top)/b.height-.5)*2;
      nudge.style.transform="translate3d("+(nx*14).toFixed(1)+"px,"+(ny*9).toFixed(1)+"px,0) rotate("+(nx*.45).toFixed(2)+"deg)";
    });
    view.addEventListener("pointerleave",()=>{nudge.style.transform=""});
  }
  if(soft){
    let sx=0,sy=0,dg=false;
    view.addEventListener("touchstart",e=>{sx=e.touches[0].clientX;sy=e.touches[0].clientY;dg=true;nudge.classList.add("drag")},{passive:true});
    view.addEventListener("touchmove",e=>{
      if(!dg) return;
      const k=clamp((e.touches[0].clientX-sx)/150,-1,1), dy=clamp((e.touches[0].clientY-sy)*.07,-12,12);
      nudge.style.transform="translate3d("+(k*28).toFixed(1)+"px,"+dy.toFixed(1)+"px,0) rotate("+(k*.8).toFixed(2)+"deg)";
    },{passive:true});
    const rel=()=>{dg=false;nudge.classList.remove("drag");nudge.style.transform=""};
    view.addEventListener("touchend",rel,{passive:true});
    view.addEventListener("touchcancel",rel,{passive:true});
  }
  update();
})();

/* ===================== STORY (scroll-driven vertical rack) ===================== */
(function(){
  const L={"tierod_l": {"l": 1.895, "t": 61.192, "w": 10.058, "h": 110, "cx": 7.1, "cy": 66.14, "title": "Tie rod interior", "text": "Rosca limpia, tuerca de ajuste. Entra a la primera.", "dir": "up", "side": "l", "title_en": "Inner tie rod", "text_en": "Clean thread, jam nut. Fits the first time."}, "boot_l": {"l": 12.828, "t": 55.669, "w": 11.48, "h": 90, "cx": 18.86, "cy": 65.55, "title": "Fuelle y abrazadera", "text": "Goma nueva. Ni agua ni polvo al interior.", "dir": "up", "side": "l", "title_en": "Boot and clamp", "text_en": "New rubber. No water or dust gets inside."}, "tube": {"l": 24.308, "t": 56.977, "w": 26.603, "h": 120, "cx": 35.88, "cy": 65.35, "title": "Cilindro cromado", "text": "Pulido a espejo. Los sellos deslizan sin desgaste.", "dir": "up", "side": "l", "title_en": "Chrome cylinder", "text_en": "Mirror polished. Seals glide without wear."}, "bar": {"l": 26.786, "t": 76.453, "w": 28.936, "h": 50, "cx": 41.47, "cy": 84.35, "title": "Barra y sellos de pistón", "text": "Acero rectificado. Sellos nuevos, no reusados.", "dir": "dn", "side": "l", "title_en": "Rack bar and piston seals", "text_en": "Ground steel. New seals, never reused."}, "lines": {"l": 26.166, "t": 19.767, "w": 35.386, "h": 70, "cx": 46.58, "cy": 36.99, "title": "Líneas hidráulicas", "text": "Acero doblado a medida, racores de latón.", "dir": "up", "side": "l", "title_en": "Hydraulic lines", "text_en": "Steel bent to spec, brass fittings."}, "valve": {"l": 61.516, "t": 7.558, "w": 9.147, "h": 40, "cx": 65.13, "cy": 36.98, "title": "Válvula y barra de torsión", "text": "Probada a presión. Tapones azules hasta instalar.", "dir": "up", "side": "r", "title_en": "Valve and torsion bar", "text_en": "Pressure tested. Blue caps on until you install it."}, "housing": {"l": 53.025, "t": 41.424, "w": 15.379, "h": 60, "cx": 60.78, "cy": 67.37, "title": "Cuerpo de aluminio fundido", "text": "Mecanizado en las caras de montaje.", "dir": "dn", "side": "r", "title_en": "Cast aluminum housing", "text_en": "Machined on the mounting faces."}, "pinion": {"l": 68.404, "t": 57.703, "w": 9.475, "h": 100, "cx": 72.98, "cy": 65.75, "title": "Piñón, rodamiento y tuerca", "text": "Torqueado y verificado en fábrica.", "dir": "up", "side": "r", "title_en": "Pinion, bearing and nut", "text_en": "Torqued and verified at the factory."}, "boot_r": {"l": 77.879, "t": 55.959, "w": 9.074, "h": 90, "cx": 82.08, "cy": 65.61, "title": "Fuelle y abrazadera", "text": "Goma nueva. Ni agua ni polvo al interior.", "dir": "up", "side": "r", "title_en": "Boot and clamp", "text_en": "New rubber. No water or dust gets inside."}, "tierod_r": {"l": 88.083, "t": 61.337, "w": 10.058, "h": 110, "cx": 92.94, "cy": 66.03, "title": "Tie rod interior", "text": "Rosca limpia, tuerca de ajuste. Entra a la primera.", "dir": "up", "side": "r", "title_en": "Inner tie rod", "text_en": "Clean thread, jam nut. Fits the first time."}};
  const sec=document.getElementById("story"); if(!sec) return; const stage=sec.querySelector(".stage"), ex=document.getElementById("ex");
  const layers=[...ex.querySelectorAll(".layer")].sort((a,b)=>L[a.dataset.k].cx-L[b.dataset.k].cx); // top to bottom
  const N=layers.length;
  const prog=document.getElementById("progress"); prog.innerHTML=layers.map(()=>"<i></i>").join(""); const dots=[...prog.children];
  const co=document.getElementById("callout"), ln=co.querySelector(".ln"), box=co.querySelector(".box");
  let cur=-1;
  function place(img){
    const m=L[img.dataset.k], r=img.getBoundingClientRect(), s=stage.getBoundingClientRect();
    const cy=r.top+r.height/2-s.top;
    const side=m.cy<55?"left":"right"; // parts sticking out to the right get the text on the left
    co.className="callout on "+side;
    const gap=18, len=Math.max(40,Math.min(120,s.width*0.08));
    if(side==="right"){ const x=r.right-s.left+gap; co.style.left=x+"px"; co.style.top=cy+"px"; ln.style.left="0"; ln.style.width=len+"px"; box.style.left=(len+10)+"px"; box.style.right="auto"; }
    else { const x=r.left-s.left-gap; co.style.left=x+"px"; co.style.top=cy+"px"; ln.style.left=(-len)+"px"; ln.style.width=len+"px"; box.style.right=(len+10)+"px"; box.style.left="auto"; }
  }
  function setStep(k){
    if(k===cur) return; cur=k;
    stage.classList.toggle("intro",k===0); stage.classList.toggle("step",k>0);
    layers.forEach((l,i)=>l.classList.toggle("on",i===k-1));
    dots.forEach((d,i)=>d.classList.toggle("on",i===k-1));
    if(k>0){
      const img=layers[k-1], m=L[img.dataset.k];
      document.getElementById("cnum").textContent=String(k).padStart(2,"0")+" / "+String(N).padStart(2,"0");
      document.getElementById("ctitle").textContent=LANG==="en"?m.title_en:m.title;
      document.getElementById("ctext").textContent=LANG==="en"?m.text_en:m.text;
      co.classList.remove("on"); requestAnimationFrame(()=>requestAnimationFrame(()=>place(img)));
    } else co.classList.remove("on");
  }
  const intro=document.getElementById("intro");
  function update(){
    const r=sec.getBoundingClientRect(), vh=Math.min(innerHeight,900);
    const scrolled=Math.max(0,-r.top), introPx=vh*0.15, stepPx=vh*0.8;
    // headline fades over the first half screen of scroll; the first part lights up halfway through that fade
    const from=introPx; // phrase stays; first part lights up after a short lead-in
    let k=scrolled<from?0:1+Math.floor((scrolled-from)/stepPx);
    setStep(Math.min(N,k));
  }
  addEventListener("scroll",update,{passive:true}); addEventListener("resize",()=>{cur=-1;update()}); update();
  window.__storyRefresh=()=>{cur=-1;update()};
})();

applyLang();
renderPopular();

}).catch(e=>console.error("RAK: no se pudo cargar racks.json",e));
})();
